import { render } from "./PrivacyComponent.vue?vue&type=template&id=67440aab"
import script from "./PrivacyComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyComponent.vue?vue&type=script&lang=js"
script.render = render

export default script